var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunications({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M30.03 60.47a93.748 93.748 0 01-8.143-7.236c-7.439-7.4-14.033-16.383-18.154-26.597a6.029 6.029 0 011.941-6.965c2.343-1.768 4.772-3.23 7.304-4.347a6.003 6.003 0 016.958 1.716 31.223 31.223 0 014.06 6.597 6.022 6.022 0 01-.331 5.551 4.023 4.023 0 01-.382.609 6.034 6.034 0 00-.412 6.606c2.051 3.392 4.64 6.056 7.349 8.75 2.582 2.569 5.331 5.214 8.832 7.255a5.98 5.98 0 006.552-.45.29.29 0 01.083-.091 5.964 5.964 0 015.977-.66 28.577 28.577 0 016.566 3.944 5.997 5.997 0 011.732 7.006c-1.12 2.504-2.584 4.905-4.367 7.21a6.01 6.01 0 01-6.956 1.897 51.71 51.71 0 01-4.42-1.892"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke fill",
    d: "M71.678 19.314c0-8.832-7.191-16.002-16.048-16.002s-16.047 7.17-16.047 16.002c0 2.469.573 4.9 1.669 7.106a2.38 2.38 0 01.2 1.606c-.287 1.307-.863 3.854-1.3 5.784a1.525 1.525 0 001.911 1.8l5.72-1.66a2.385 2.385 0 011.612.1 15.97 15.97 0 006.235 1.265c8.857 0 16.048-7.17 16.048-16.001zm-16.048-4.35c2.694 0 4.88 2.177 4.88 4.857s-2.186 4.856-4.88 4.856-4.881-2.176-4.881-4.856c0-2.68 2.187-4.856 4.88-4.856z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunications);
export default __webpack_public_path__ + "static/media/communications.0de20c1bc27612a4ff2095baebe97eba.svg";
export { ForwardRef as ReactComponent };